<template>
  <div class="page">
    <div class="row flex topCardGrid">
        <sp-card :valor="buscarTopPorRegiaoOntem ? buscarTopPorRegiaoOntem[0].recebidas : 0" :descricao="$t('atendimento.boletim.card.recebidasOntem', { periodo: 'Ontem', nota: '' })" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef })" :icon="iconeCardOntem.tipo" :iconColor="iconeCardOntem.cor" :iconHint="iconeCardOntem.hint" />
        <sp-card :valor="buscarTopPorRegiaoAnteontem ? buscarTopPorRegiaoAnteontem[0].recebidas : 0" :descricao="$t('atendimento.boletim.card.recebidasAnteOntem')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef })" :icon="iconeCardAnteontem.tipo" :iconColor="iconeCardAnteontem.cor" :iconHint="iconeCardAnteontem.hint" />
        <sp-card :valor="buscarTopPorRegiao7dias ? buscarTopPorRegiao7dias[0].recebidas : 0" :descricao="$t('atendimento.boletim.card.recebidas7Dias')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef })"/>
        <sp-card :valor="buscarTopPorRegiao30dias ? buscarTopPorRegiao30dias[0].recebidas : 0" :descricao="$t('atendimento.boletim.card.recebidas30Dias')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef })"/>
    </div>
    <div class="row flex">
      <div class="flex sm12 md12 lg12">
        <sp-360-panel id="painelEstoque" :title="$t('atendimento.boletim.historicoComparativoEstoque')" :footerText=" $t('rodape.fonteData', {fonte: fonte, data: dataRef })" :footerComplementar="$t('')" >
          <div class="flex">
            <div class="chart">
                <sp360-chart :data="chartDataEvolucaoEstoque.chartData" type="line" :options="chartDataEvolucaoEstoque.options" />
            </div>
          </div>
        </sp-360-panel>
      </div>
    </div>
    <div class="row flex">
      <div class="flex xs12 sm12 lg7 md7">
        <sp-360-panel  id="cardBoletimtop10" :title="$t('atendimento.boletim.tabelaBoletimtop10')" :footerText=" $t('rodape.fonteData', {fonte: fonte, data: dataRef })" :tooltipOptions="tooltipTop" v-bind:justifyVertically="true" >
          <div class="flex">
            <sp360-data-table id="tabelaBoletimtop10" ref="tabelaBoletimtop10" name="tabelaBoletimtop10"
              :apiMode="false"
              :data="tabelaTopDez.data"
              :fields="tabelaTopDez.campos"
              :perPage="tabelaTopDez.itemsPerPage"
              :onEachSide="tabelaTopDez.onEachSide"
              :dataModeFilterableFields="tabelaTopDez.dataModeFilterableFields"
              :sortFunctions="tabelaTopDez.sortFunctionsServ"
              :filterInputShown="true"
              :striped="true"
              v-on:row-clicked="handleClick($event)"
              :clickable="true"
              :hoverable="true"
              table-height="34em"
            />
          </div>
        </sp-360-panel>
      </div>
      <div class="flex xs12 sm12 md5 lg5 piechartCanais">
        <sp-360-panel id="painelCanal" :title="$t('atendimento.boletim.comparativoCanaisEntrada')" :footerText=" $t('rodape.fonteData', {fonte: fonte, data: dataRef })" :footerComplementar="$t('')" v-bind:justifyVertically="true" >
          <div class="flex">
              <sp360-chart :data="chartCanais.data" :options="chartCanais.options" type="donut" title="" />
          </div>
        </sp-360-panel>
      </div>
    </div>
    <va-modal show.sync="true" ref="modalGeoref" :okText="'fechar'" :okClass="'btn btn-primary btn-sm'"
    size="large" v-model="showBoletimModal" :title="'Serviços Georreferenciados'" :cancelText="''" >
      <template slot="default">
        <div class="row flex">
          <div class="flex">
            <sp-360-panel :title="'Serviços Georreferenciados: '+ servicoBuscado" :footerText=" $t('rodape.fonteData', {fonte: fonte, data: dataRef })" :tooltipOptions="tooltipGeo">
              <div class="row">
                <div class="flex lg6 md6 sm12"> <!-- Top 5 Subs -->
                  <sp360-data-table id="tabelatop5" ref="tabelatop5"
                    :apiMode="false"
                    :data="tabelaTopCinco.data"
                    :fields="tabelaTopCinco.campos"
                    :perPage="tabelaTopCinco.itemsPerPage"
                    :onEachSide="tabelaTopCinco.onEachSide"
                    :dataModeFilterableFields="tabelaTopCinco.dataModeFilterableFields"
                    :sortFunctions="tabelaTopCinco.sortFunctionsServ"
                    :filterInputShown="true"
                    :striped="false"
                    table-height="20rem"
                  />
                </div>
                <div class="flex lg6 md6 sm12"> <!-- Top 5 Servicos -->
                  <sp360-chart :data="graficoSub.chartData" :options="graficoSub.options" type="pie" class="piechart" />
                </div>
              </div>
            </sp-360-panel>
          </div>
        </div>
      </template>
    </va-modal>
    <div class="row flex">
      <div class="flex">
        <sp-360-panel :title="$t('atendimento.boletim.tabelaTopOuvidoria')" :footerText=" $t('rodape.fonteData', {fonte: fonte, data: dataRef })" >
          <div class="row">
            <div class="flex lg12 md12 sm12">
              <sp360-data-table id="tabelaTopOuvidoria" ref="tabelaTopOuvidoria"
                :apiMode="false"
                :data="tabelaTopServicos.data"
                :fields="tabelaTopServicos.campos"
                :perPage="tabelaTopServicos.itemsPerPage"
                :onEachSide="tabelaTopServicos.onEachSide"
                :dataModeFilterableFields="tabelaTopServicos.dataModeFilterableFields"
                :sortFunctions="tabelaTopServicos.sortFunctionsServ"
                :filterInputShown="true"
                :striped="false"
                table-height="20rem"
                />
            </div>
          </div>
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import CorUtils from '@/utils/CorUtils'
import Constantes from '@/utils/ConstantesGlobais'
import MetodosGlobais from '@/utils/MetodosGlobais'
import Linha from '@/components/statistics/charts/GraficoLinha.vue'
import ChartJsPluginDataLabels from 'chartjs-plugin-datalabels'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import SpCard from '@/components/ui/cards/SP360Card'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'

export default {
  name: 'estoque-servicos',
  components: {
    Linha,
    Sp360Chart,
    Sp360Panel,
    Sp360DataTable,
    SpCard,
  },
  data: function () {
    return {
      disclaimer1: '¹Recebidas 30 dias (%): taxa de variação dos 30 dias anteriores em comparação ao dia do boletim <br> ²Recebidas: quantidade total registrada no período atual <br> ³Assertividade diária (%): taxa de solicitações concluídas referente ao estoque (concluídas D-1 e Estoque em D-2) <br> \u2074 TMA: tempo médio de atendimento (números absolutos, em dias)',
      disclaimer2: '²Recebidas: quantidade total registrada no período atual',
      disclaimer3: '³Assertividade diária (%): taxa de solicitações concluídas referente ao estoque (concluídas D-1 e Estoque em D-2)',
      disclaimer4: '\u2074 TMA: tempo médio de atendimento (números absolutos, em dias)',
      showBoletimModal: false,
      iconeCardOntem: {
        tipo: '',
        cor: '',
        hint: ''
      },
      iconeCardAnteontem: {
        tipo: '',
        cor: '',
        hint: ''
      },
      fonte: '',
      dataRef: '',
      subSel: '',
      periodo: '',
      nota: '',
      id_ouvidoria: [2630, 3616, 824, 952, 1071, 1545, 1611, 1727, 1700, 1037, 3831, 1725, 938, 945, 2652, 2641, 1305, 1720, 3113, 3256, 897, 3316, 920, 3327, 3726, 3798, 1393, 3793, 906, 1484, 756, 2655, 3222, 773, 743, 2633, 3314, 915, 774, 898, 970, 2634, 3111, 3270, 939, 2636, 3856, 770, 925, 811, 858, 1034, 3580, 908, 2745, 3514, 808, 983, 1008, 1542, 1715, 3371, 3619, 745, 753, 771, 919, 924, 931, 934, 936, 950, 1026, 3179, 3587, 3667, 3677, 3731, 3843, 1001, 1489, 3170, 3255, 3302, 3333, 3385, 3574, 3585, 3854, 3855, 4002, 719, 720, 752, 814, 911, 965, 968, 982, 994],
      top10chartData: { datasets: [], labels: [] },
      tabelaTopDez: {
        data: [],
        campos: [],
        itemsPerPage: 0,
        onEachSide: 1,
        dataModeFilterableFields: [],
        sortFunctions: [],
      },
      tabelaTopCinco: {
        data: [],
        campos: [],
        itemsPerPage: 0,
        onEachSide: 1,
        dataModeFilterableFields: [],
        sortFunctions: [],
      },
      tabelaTopServicos: {
        data: [],
        campos: [],
        itemsPerPage: 0,
        onEachSide: 1,
        dataModeFilterableFields: [],
        sortFunctions: [],
      },
      top10chartOptions: {
        responsive: true,
        maintainAspectRatio: true,
      },
      ouvidoria7Dias: {},
      termoBuscaSituacao: null,
      buscarTopPorRegiaoOntem: 0,
      buscarTopPorRegiaoAnteontem: 0,
      buscarTopPorRegiao30dias: 0,
      buscarTopPorRegiao7dias: 0,
      graficoSub: { chartData: {}, options: {} },
      servicoBuscado: '',
      chartDataEvolucaoEstoque: { chartData: {}, options: {} },
      chartCanais: { data: {}, options: {} },
      tooltipGeo: { content: 'Algumas Serviços não são Georreferenciados', placement: 'bottom' },
      tooltipTop: { content: `¹Recebidas 30 dias (%): taxa de variação dos 30 dias anteriores em comparação ao dia do boletim <br><br> 
      ²Recebidas: quantidade total registrada no período atual <br><br> 
      ³Assertividade diária (%): taxa de solicitações concluídas referente ao estoque (concluídas D-1 e Estoque em D-2) <br><br> 
      \u2074TMA: tempo médio de atendimento (números absolutos, em dias) <br><br>
      Clique no serviço para detalhes do georreferenciamento`, placement: 'bottom' },

    }
  },

  created () {
    Promise.all([
      this.$store.dispatch('servicos156/buscarEvolucaoEstoqueSolicitacao', { agrupamento: 'MENSAL' }),
      // serivços por regiao 1 ~ 3
      this.$store.dispatch('servicos156/buscarTopPorRegiao', { topReqs: 200, intervalo: 'ULTIMO_MES', ordenacao: 'recebidas' }),
      this.$store.dispatch('servicos156/buscarTopPorRegiao', { topReqs: 200, intervalo: 'ONTEM', ordenacao: 'recebidas' }),
      this.$store.dispatch('servicos156/buscarTopPorRegiao', { topReqs: 200, intervalo: 'ANTEONTEM', ordenacao: 'recebidas' }),

      // ouvidoria 4 ~ 7
      this.$store.dispatch('servicos156/buscarTopServicosDemandados', { topReqs: null, intervalo: 'ULTIMO_MES' }),
      this.$store.dispatch('servicos156/buscarTopServicosConsolidados', { topReqs: Constantes.PARAMETROS_DASHBOARD.SP156.QTD_SERVICOS_POR_REGIAO_ULTIMO_MES_REQUEST, intervalo: 'DESDE_SEMPRE', ordenacao: 'recebidas' }),
      this.$store.dispatch('servicos156/buscarEvolucaoEstoqueSolicitacao', { agrupamento: 'ONTEM' }),
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaPorRegiao', { top: 100, intervalo: 'ULTIMO_MES', ordenacao: 'recebidas', filtroId: this.id_ouvidoria }),
      // Ouvidoria  8 ~ 10
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaPorRegiao', { top: 200, intervalo: 'ULTIMO_MES', ordenacao: 'recebidas' }),
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaPorRegiao', { top: 200, intervalo: 'ONTEM', ordenacao: 'recebidas' }),
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaPorRegiao', { top: 200, intervalo: 'ANTEONTEM', ordenacao: 'recebidas' }),
      // estoque 11 ~ 13
      this.$store.dispatch('servicos156/buscarTopServicosConsolidados', { topReqs: 200, intervalo: 'ONTEM', ordenacao: 'recebidas' }),
      this.$store.dispatch('servicos156/buscarTopServicosConsolidados', { topReqs: 200, intervalo: 'ANTEONTEM', ordenacao: 'recebidas' }),
      this.$store.dispatch('servicos156/buscarTopServicosConsolidados', { topReqs: 200, intervalo: 'ULTIMO_MES', ordenacao: 'recebidas' }),
      // canais 14 ~ 16
      this.$store.dispatch('servicos156/buscarSolicitacoesPorCanal'),
      this.$store.dispatch('ouvidoria/topServicosOuvidoriaPorRegiao', { top: 200, intervalo: 'ULTIMA_SEMANA', ordenacao: 'recebidas' }),
      this.$store.dispatch('servicos156/buscarTopPorRegiao', { topReqs: 200, intervalo: 'ULTIMA_SEMANA', ordenacao: 'recebidas' }),

    ])
      .then(
        (respostas) => {
          this.cores = CorUtils.getVetorCoresPorTom('medio')
          this.fonte = respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte
          this.dataRef = new Date(respostas[0].data.data_referencia_dado).toLocaleDateString('pt-BR')

          this.EvolucaoEstoqueSolicitacao = respostas[0].data.data

          this.buscarTopPorRegiao30dias = _.orderBy(respostas[1].data.data, 'recebidas', ['desc'])
          this.buscarTopPorRegiaoOntem = _.orderBy(respostas[2].data.data, 'recebidas', ['desc'])
          this.buscarTopPorRegiaoAnteontem = _.orderBy(respostas[3].data.data, 'recebidas', ['desc'])
          this.buscarTopPorRegiao7dias = _.orderBy(respostas[16].data.data, 'recebidas', ['desc'])

          this.iconeCardOntem = this.definirIconeVariacaoEmRelacaoA30Dias(this.buscarTopPorRegiaoOntem[0].recebidas)
          this.iconeCardAnteontem = this.definirIconeVariacaoEmRelacaoA30Dias(this.buscarTopPorRegiaoAnteontem[0].recebidas)

          this.buscarTopServicosDemandados = respostas[4].data.data
          this.buscarTopServicosConsolidados = respostas[5].data.data

          this.ontem = respostas[11].data.data
          this.anteontem = respostas[12].data.data
          this.ultimoMes = respostas[13].data.data
          this.estoque = this.solicitacoesEstoque(this.ontem, this.anteontem, this.ultimoMes)
          // Atribuições Concluidas - Construção dos elementos da pagina
          this.tabelaTopDez = this.defineTabelaTop10Servicos()
          this.tabelaTopDez.data = this.estoque.slice(0, 10)
          this.top10chartData = this.popularGraficoTop10(this.estoque.slice(0, 10))
          this.top10chartOptions = this.getchartOptions('Solicitações  ', 'Serviços')

          // Mostar as Subs com maior demanda de um Serviço X
          this.buscarTopPorRegiao = _.orderBy(respostas[2].data.data, 'recebidas', ['desc'])
          this.buscarTopPorRegiao.forEach(el => {
            el.servicos = _.orderBy(el.servicos, 'recebidas', ['desc'])
          })
          this.geral = this.buscarTopPorRegiao.shift()
          this.seletorDeServicosPorSub()
          this.tabelaTopCinco = this.defineTabelaTop5Subprefeituras()

          // Ouvidoria Mostrar as top 5 Reclamações mais recebidas em D-1 e D-2
          this.ouvidoriaOntem = _.orderBy(respostas[9].data.data[0].servicos, 'servico_id', ['desc'])
          this.removerServicoPorId(this.ouvidoriaOntem, 2630)
          this.ouvidoriaUltimos7dias = _.orderBy(respostas[15].data.data[0].servicos, 'servico_id', ['desc'])
          this.removerServicoPorId(this.ouvidoria7Dias, 2630)
          this.ouvidoriaAnteontem = _.orderBy(respostas[10].data.data[0].servicos, 'servico_id', ['desc'])
          this.removerServicoPorId(this.ouvidoriaAnteontem, 2630)
          this.ouvidoriaUltimoMes = _.orderBy(respostas[8].data.data[0].servicos, 'servico_id', ['desc'])
          this.removerServicoPorId(this.ouvidoriaUltimoMes, 2630)
          this.ouvidoriaOntem.forEach(ontem => {
            this.ouvidoriaUltimos7dias.some((semana,i) => {
              if (ontem.servico_id === semana.servico_id) { // procura no top serviços de anteontem D-2 os serviços listados na lista de ontem D-1
                ontem.ultimaSemana = semana
                ontem.recebidasUltimaSemana = semana.recebidas
                return true
              } else { // Se não encontrar o item com mesmo servico_id atribui um Null e o valor de recebidasAnteontem = 0 Isso previne erros na renderização das tabelas
                ontem.ultimaSemana = null
                ontem.recebidasUltimaSemana = NaN
              }
            })
            this.ouvidoriaUltimoMes.some( (ultimoMes,i) => {
              if (ontem.servico_id === ultimoMes.servico_id) { // procura no top serviços de anteontem D-2 os serviços listados na lista de ontem D-1
                ontem.ultimoMes = ultimoMes
                ontem.recebidasUltimoMes = ultimoMes.recebidas
                return true
              } else { // Se não encontrar o item com mesmo servico_id atribui um Null e o valor de recebidasAnteontem = 0 Isso previne erros na renderização das tabelas
                ontem.ultimoMes = null
                ontem.recebidasUltimoMes = NaN
              }
            })
          })

          // Cria Tabela de Ouvidoria
          this.tabelaTopServicos = this.defineTabelaOuvidoria()
          this.tabelaTopServicos.data = _.orderBy(this.ouvidoriaOntem, 'recebidas', ['desc'])
          this.tabelaTopServicos.data = this.tabelaTopServicos.data

          // Evolução do Estoque
          this.chartDataEvolucaoEstoque = this.popularGraficoEstoque(this.EvolucaoEstoqueSolicitacao, 'estoque.evolucaoEstoqueX', 'estoque.evolucaoEstoqueY')
          // Canais de Entrada
          this.canaisEntrada = respostas[14].data.data
          this.montarGraficoCanais(this.canaisEntrada, 'Canais de Entrada')
        }
      )
      .catch(
        (error) => {
          console.error(error)
        })
  },

  methods: {
    buscaSolicitacoes: _.debounce(function (termoBusca) {
      this.filtraTermoBusca(termoBusca, this.estoque, this.tabelaTopDez)
    }, 400),

    openModalGeoref (event) {
      this.showBoletimModal = !this.showBoletimModal
    },

    filtraTermoBusca (termoBusca, dataset) {
      if (!termoBusca) {
        this.termoBuscaSituacao = ''
        termoBusca = this.termoBuscaSituacao
      }
      let dados = []
      if ((!Number.isNaN(parseInt(termoBusca))) && termoBusca !== '') {
        dados = MetodosGlobais.filterByNumber(dataset, termoBusca)
      } else {
        dados = MetodosGlobais.filterByString(dataset, termoBusca)
      }
      return dados
    },

    definirIconeVariacaoEmRelacaoA30Dias(valor) {
      let media30Dias = Math.round(this.buscarTopPorRegiao30dias[0].recebidas/30)
      let iconeCard = {}
      if(valor > media30Dias) {
        iconeCard.tipo = 'fa fa-arrow-up'
        iconeCard.cor = 'danger'
        iconeCard.hint = `Crescimento nas solicitações recebidas em relação a média de ${media30Dias.toLocaleString()} dos últimos 30 dias`
      }
      else if(media30Dias > valor) {
        iconeCard.tipo = 'fa fa-arrow-down'
        iconeCard.cor = 'success'
        iconeCard.hint = `Diminuição nas solicitações recebidas em relação a média de ${media30Dias.toLocaleString()} dos últimos 30 dias`
      }
      else {
        iconeCard.tipo = 'fa fa-arrow-right'
        iconeCard.cor = ''
        iconeCard.hint = `Mesmo número de solicitações recebidas em relação a média de ${media30Dias.toLocaleString()} dos últimos 30 dias`
      }
      return iconeCard
    },

    defineTabelaTop10Servicos () {
      return {
        itemsPerPage: 10, // Constantes.PARAMETROS_DASHBOARD.SP156.QTD_DE_LINHAS_TABELAS_SERVICO_POR_REGIAO,
        data: [],
        campos: [
          {
            name: 'servico_desc',
            title: this.$t('atendimento.boletim.top10Servicos'),
            // sortField: 'servico_desc',
            width: '60%',
          },
          {
            name: '__slot:estoque',
            title: ' ',
            dataClass: 'action-slot',
            width: '2%',
          },
          {
            name: 'variacao',
            // sortField: 'variacao', // qual o atributo que é usado para ordenação ( em geral é o mesmo atributo name)
            title: this.$t('atendimento.boletim.variacao', { periodo: '30 dias', nota: '1' }), // titulo da coluna
            callback: function (value) { return !isNaN(parseFloat(value)) ? value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + '%' : 'n/d' }, // Esse metodo usamos para formatar o dados...
            dataClass: 'dataBold',
            width: '8%',
          },
          {
            name: 'recebidas', // nome do atributo
            // sortField: 'recebidas', // qual o atributo que é usado para ordenação ( em geral é o mesmo atributo name)
            title: this.$t('atendimento.boletim.recebidas', { periodo: 'Ontem', nota: '' }),
            callback: function (value) { return !isNaN(parseFloat(value)) ? value.toLocaleString('pt-BR', { maximumFractionDigits: 0 }) : 'n/d' }, // Esse metodo usamos para formatar o dados...
            dataClass: 'dataBold ',
            width: '10%',
          },
          {
            name: 'assertividade',
            // sortField: 'assertividade',
            title: this.$t('atendimento.boletim.assertividade', { nota: '3' }),
            callback: function (value) { return !isNaN(parseFloat(value)) ? value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + '%' : 'n/d' },
            dataClass: 'dataBold ',
            width: '10%',
          },
          {
            name: 'media_atendimento_dias',
            // sortField: 'media_atendimento_dias',
            title: this.$t('atendimento.boletim.tma', { nota: '4' }),
            callback: function (value) { return !isNaN(parseFloat(value)) ? value.toLocaleString('pt-BR', { maximumFractionDigits: 0 }) : 'n/d' },
            dataClass: 'dataBold ',
            width: '10%',
          },
        ],
        onEachSide: 1,
        dataModeFilterableFields: ['servico_desc'],
        sortFunctionsServ: {
          'servico_desc': MetodosGlobais.ordenaTabela,
          'recebidas': MetodosGlobais.ordenaTabelaParseInt,
          'finalizadas': MetodosGlobais.ordenaTabelaParseInt,
          'media_atendimento_dias': MetodosGlobais.ordenaTabelaParseInt,
        },
      }
    },

    defineTabelaTop5Subprefeituras () {
      return {
        itemsPerPage: 5, // Constantes.PARAMETROS_DASHBOARD.SP156.QTD_DE_LINHAS_TABELAS_SERVICO_POR_REGIAO,
        data: [],
        campos: [
          {
            name: 'nome',
            title: this.$t('atendimento.boletim.subPrefeituras'),
            sortField: 'nome',
            width: '50%',
          },
          {
            name: 'chaveTopSub',
            sortField: 'chaveTopSub',
            title: this.$t('atendimento.boletim.solicitacoesOntem'),
            callback: MetodosGlobais.thousandSeparator,
            dataClass: 'cinzaClaro',
            width: '25%',
          },
          {
            name: 'chaveEstoque',
            sortField: 'chaveEstoque',
            title: this.$t('atendimento.boletim.solicitacoesEstoqueUltimoMes'),
            callback: MetodosGlobais.thousandSeparator,
            dataClass: 'cinza',
            width: '25%',
          },
        ],
        onEachSide: 1,
        sortFunctionsServ: {
          'chaveTopSub': MetodosGlobais.ordenaTabelaParseInt,
          'chaveEstoque': MetodosGlobais.ordenaTabelaParseInt,
          'nome': MetodosGlobais.ordenaTabela,
        },
      }
    },

    defineTabelaOuvidoria () {
      return {
        itemsPerPage: 5, // Constantes.PARAMETROS_DASHBOARD.SP156.QTD_DE_LINHAS_TABELAS_SERVICO_POR_REGIAO,
        data: [],
        campos: [
          {
            name: 'servico_desc',
            title: this.$t('mainDashboard.tableFields.servicos'),
            sortField: 'servico_desc',
            width: '40%',
          },
          {
            name: 'recebidas', // nome do atributo
            sortField: 'recebidas', // qual o atributo que é usado para ordenação ( em geral é o mesmo atributo name)
            title: this.$t('atendimento.boletim.recebidas', { periodo: 'Ontem', nota: '' }), // titulo da coluna
            callback: (x) => isNaN(x) ? 'n/d' : x.toLocaleString('pt-BR'), // Esse metodo usamos para formatar o dados...
            width: '20%', // largura da coluna
            dataClass: 'dataBold',
          },
          {
            name: 'recebidasUltimaSemana', // nome do atributo
            sortField: 'recebidasUltimaSemana', // qual o atributo que é usado para ordenação ( em geral é o mesmo atributo name)
            title: this.$t('atendimento.boletim.recebidasUltimaSemana', { data: '' }), // titulo da coluna
            callback: (x) => isNaN(x) ? 'n/d' : x.toLocaleString('pt-BR'), // Esse metodo usamos para formatar o dados...
            width: '20%', // largura da coluna
            dataClass: 'dataBold cinzaClaro',
          },
          {
            name: 'recebidasUltimoMes', // nome do atributo
            sortField: 'recebidasUltimoMes', // qual o atributo que é usado para ordenação ( em geral é o mesmo atributo name)
            title: this.$t('atendimento.boletim.recebidasUltimoMes', { data: '' }), // titulo da coluna
            callback: (x) => isNaN(x) ? 'n/d' : x.toLocaleString('pt-BR'), // Esse metodo usamos para formatar o dados...
            width: '20%', // largura da coluna
            dataClass: 'dataBold cinza',
          },
        ],
        onEachSide: 1,
        dataModeFilterableFields: ['nomeServ'],
        sortFunctionsServ: {
          'solicitacoesRecebidas': MetodosGlobais.ordenaTabela,
          'finalizadas': MetodosGlobais.ordenaTabela,
          'tempoMedio': MetodosGlobais.ordenaTabelaParseInt,
        },
      }
    },

    organizandoDados (dados) {
      dados.forEach(el => {
        this.buscarTopPorRegiao30dias[0].servicos.forEach(o => {
          if (el.servico_id === o.servico_id) {
            el.estoque = '---'
            el.arrowUp = el.recebidas >= el.finalizadas ? { class: 'red-arrow', title: this.$t('mainDashboard.crescimentoEstoque') } : false
            el.arrowDown = el.recebidas < el.finalizadas ? { class: 'green-arrow', title: this.$t('mainDashboard.diminuicaoEstoque') } : false
            el.col = el.recebidas >= el.finalizadas ? { class: 'vermelho', value: ((el.recebidas / el.finalizadas) * 100) } : { class: 'verde', value: ((el.recebidas / el.finalizadas) * 100) }
            el.variacao = (((el.recebidas - o.recebidas) / el.recebidas) * 100) // ((el.recebidas / o.recebidas) * 100)
          }
        })
        this.buscarTopPorRegiaoAnteontem[0].servicos.forEach(o => {
          if (el.servico_id === o.servico_id) {
            el.assertividade = ((el.finalizadas / o.recebidas) * 100)
          }
        })
      })
      return dados
    },

    solicitacoesEstoque (ontem, anteontem, ultimoMes) {
      ontem.forEach(el => {
        ultimoMes.forEach(o => {
          if (el.servico_id === o.servico_id) {
            el.estoque = '---'
            el.arrowUp = el.recebidas >= el.finalizadas ? { class: 'red-arrow', title: this.$t('mainDashboard.crescimentoEstoque') } : false
            el.arrowDown = el.recebidas < el.finalizadas ? { class: 'green-arrow', title: this.$t('mainDashboard.diminuicaoEstoque') } : false
            // el.col = el.recebidas >= el.finalizadas ? { class: 'vermelho', value: ((el.recebidas / el.finalizadas) * 100) } : { class: 'verde', value: ((el.recebidas / el.finalizadas) * 100) }
            el.variacao = ((el.recebidas / o.recebidas) * 100)
          }
        })
        anteontem.forEach(o => {
          if (el.servico_id === o.servico_id) {
            el.assertividade = ((el.finalizadas / o.recebidas))
          }
        })
        this.buscarTopPorRegiaoOntem[0].servicos.forEach(o => {
          if (el.servico_id === o.servico_id) {
            el.media_atendimento_dias = o.media_atendimento_dias
          }
        })
      })

      return ontem
    },

    rodapeData (d, data) {
      return MetodosGlobais.rodapeData(d, data)
    },

    tooltipsCallback (perc, separadorMilhar) {
      return {
        title: function (tooltipItem) {
          return tooltipItem[0].label
        },
        label: function (tooltipItem, data) {
          var label = ''
          if (separadorMilhar) { label += MetodosGlobais.thousandSeparator(tooltipItem.yLabel) } else { label += tooltipItem.yLabel }
          if (label && perc) {
            label += '%'
          }
          return label
        },
      }
    },

    removerServicoPorId (arr, servicoId) {
      _.remove(arr, function (n) {
        return n.servico_id === servicoId
      })
    },

    popularGraficoTop10 (dados) {
      let datasets = []

      let recebidas = this.getDataset()
      recebidas.backgroundColor = '#D3EFBD'
      // recebidas.xAxisID = 'bar'
      recebidas.label = 'solicitações'

      let variacao = this.getDataset()
      variacao.label = 'variação'
      variacao.backgroundColor = this.cores.shift()
      variacao.borderColor = this.$store.getters.palette.transparent
      // variacao.xAxisID = 'point'
      variacao.pointStyle = 'triangle'
      variacao.rotation = (context) => {
        return this.estoque[context.dataIndex].arrowDown ? 180 : 0
      }

      let assertividade = this.getDataset()
      assertividade.backgroundColor = this.cores.shift()
      // assertividade.xAxisID = 'bar'
      assertividade.label = 'assertividade'

      let labels = []

      dados.forEach(o => {
        labels.push(o.servico_desc)
        recebidas.data.push(o.recebidas)
        variacao.data.push(o.variacao)
        assertividade.data.push(o.assertividade)
      })

      datasets.push(recebidas)

      let chartData = {
        datasets: datasets,
        labels: labels,
      }

      return chartData
    },

    getDataset () {
      return {
        label: '',
        fill: false,
        backgroundColor: '',
        borderColor: '',
        data: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => value.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
          font: {
            weight: 'bold',
          },
          anchor: 'end',
          // rotation: -90,
          // align: 'end',
        },
        categoryPercentage: 0.2,
        barPercentage: 1.0,
      }
    },

    getchartOptions (xAxixLabel, yAxixLabel, chartData) {
      return {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          datalabels: {
            font: {
              weight: 'bold',
            },
          },
        },
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 49,
            // bottom: 5,
          },
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
          intersect: true,
          // callbacks: {
          //   title: function (tooltipItems, data) {
          //     if (tooltipItems[0].datasetIndex === _.findIndex(chartData.datasets, (o) => o.yAxisID === 'LineAxis')) {
          //       return 'Acumulado'
          //     }
          //     var title = ''
          //     var labels = data.labels
          //     var labelCount = labels ? labels.length : 0

          //     if (tooltipItems.length > 0) {
          //       var item = tooltipItems[0]
          //       if (item.label) {
          //         title = item.label
          //       } else if (item.xLabel) {
          //         title = item.xLabel
          //       } else if (labelCount > 0 && item.index < labelCount) {
          //         title = labels[item.index]
          //       }
          //     }

          //     return title
          //   },
          //   label: function (tooltipItem, details) {
          //     if (details.datasets[tooltipItem.datasetIndex].yAxisID == 'LineAxis') {
          //       let dataset = details.datasets[tooltipItem.datasetIndex]
          //       let currentValue = dataset.data[tooltipItem.index]
          //       return currentValue.toFixed(2) + '%'
          //     } else {
          //       let dataset = details.datasets[tooltipItem.datasetIndex]
          //       let currentValue = dataset.data[tooltipItem.index]
          //       return dataset.label + ': ' + MetodosGlobais.thousandSeparator(currentValue)
          //     }
          //   },
          // },
        },
        scales: {
          yAxes: [{
            scaleLabel: {
              labelString: yAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: false,
              display: false,
            },
          }],
          xAxes: [{
            id: 'bar',
            gridLines: {
              display: true,
            },
            scaleLabel: {
              display: true,
              labelString: xAxixLabel,
            },
            ticks: {
              beginAtZero: true,
            },
          }],
        },
      }
    },

    handleClick (element, event) {
      let mostrarModal = this.seletorDeServicosPorSub(element)
      if(mostrarModal) this.openModalGeoref()
      else {
        let config = Constantes.TOASTED_INFO
        config.singleton = true
        console.log(config)
        this.showToast("Sem informações para mostrar ou o serviço não é georreferenciado", config)
      }
    },

    seletorDeServicosPorSub (element) {
      let soma = 0
      let dados = []
      if (element) {
        this.servicoBuscado = element.servico_desc
        let chave = null
        let chaveEstoque = null
        this.buscarTopPorRegiao.forEach(el => {
          chave = _.find(el.servicos, function (o) {
            return o.servico_id === element.servico_id
          })
          this.buscarTopPorRegiao30dias.forEach(el => {
            chaveEstoque = _.find(el.servicos, function (o) {
              return o.servico_id === element.servico_id
            })
          })
          let dado = { chaveTopSub: (chave ? chave.recebidas : 0), nome: el.nome, chaveEstoque: (chaveEstoque ? chaveEstoque.recebidas : 0) }
          soma += (dado.chaveTopSub + dado.chaveEstoque)
          dados.push(dado)
        })

        dados = _.orderBy(dados, 'chaveTopSub', ['desc'])
      } else {
        console.warn('Elemento indefinido na seleção da tabela: opção default acionada: []')
      }
      if(soma <= 0) return false
      // define o Grafico
      dados = _.orderBy(dados, 'chaveTopSub', ['desc'])
      this.popularGraficoSub(dados, 'chaveTopSub', 5, 'subprefeitura')

      // define a Tabela
      this.tabelaTopCinco = this.defineTabelaTop5Subprefeituras()
      this.$set(this.tabelaTopCinco, 'data', dados.slice(0, 5))
      return true
    },

    popularTabela (id, prop = 'servicos') {
      let s = _.find(this.dadosSub, (e) => e.id === id)
      this.tabela.data = (s) ? s[prop] : []
      this.footerGeral = { servico_desc: 'Totais', recebidas: s.somatorios.recebidas.toLocaleString('pt-BR'), recebidas_total: s.somatorios.recebidas_total.toLocaleString('pt-BR'), finalizadas: s.somatorios.finalizadas.toLocaleString('pt-BR') }
    },

    popularGraficoSub (dados, atributo, fatias, datasetLabel) {
      let chartData = { datasets: [], labels: [] }

      let dataset = {
        label: datasetLabel,
        backgroundColor: CorUtils.getVetorCoresPorTom('medio').slice(0, 5),
        data: [],
        datalabels: {
          color: 'black',
          font: {
            weight: 'bold',
          },
          anchor: 'end',
          // rotation: -90,
          align: 'start',
        },
      }

      let outros = 0

      fatias = fatias <= 0 ? 1 : fatias - 1
      for (let index = 0; index < dados.length; index++) {
        const o = dados[index]

        if (index <= fatias && o[atributo] > 0) {
          chartData.labels.push(o.nome)
          dataset.data.push(o[atributo])
        } else if (o[atributo] > 0) {
          outros += o[atributo]
        }
      }
      chartData.labels.push('OUTRAS')

      if (outros > 0) {
        dataset.data.push(outros)
      }
      chartData.datasets.push(dataset)

      this.graficoSub.chartData = chartData

      this.graficoSub.options = {
        legend: {
          display: false,
        },
        plugins: {
          datalabels: {
            display: true,
          },
        },
      }
    },

    popularGraficoEstoque (dados, legendaX, legendaY) {
      let d = dados.slice(dados.length - 6, dados.length)
      let d2 = dados.slice(dados.length - 18, dados.length - 12)
      let chartData = { datasets: [], options: {}, labels: [] }
      let cores = _.cloneDeep(this.cores)

      let corDataset = ''
      this.proporcao = []
      let vectorFinalizadas = []
      let vectorIndeferidas = []
      let vectorCanceladas = []
      let vectorDeferidas = []
      let vectorAbertas = []
      let vectorAbertas2 = []
      let vetorEstoque = []
      let vetorEstoque2 = []

      for (let index = 0; index <= (d.length - 1); index++) {
        const e = d[index]
        let data = (MetodosGlobais.mapeiaMesAbreviacao(MetodosGlobais.dateToJsonDateParts(e.data_estado_estoque).mes).nome)
        chartData.labels.push(MetodosGlobais.mapeiaMesAbreviacao(MetodosGlobais.dateToJsonDateParts(e.data_estado_estoque).mes).nome)
        if (index - 1 >= 0) {
          if (e.finalizadas) {
            vectorFinalizadas.push({ x: data, y: (e.finalizadas - d[index - 1].finalizadas) })
          }
          if (e.canceladas) {
            vectorCanceladas.push({ x: data, y: (e.canceladas - d[index - 1].canceladas) })
          }
          if (e.deferidas) {
            vectorDeferidas.push({ x: data, y: (e.deferidas - d[index - 1].deferidas) })
          }
          if (e.indeferidas) {
            vectorIndeferidas.push({ x: data, y: (e.indeferidas - d[index - 1].indeferidas) })
          }
          if (e.abertas) {
            this.proporcao.push((d[index - 1].abertas / e.abertas) * 100)
            vectorAbertas.push({ x: data, y: (e.abertas - d[index - 1].abertas) })
          }
        }
        vetorEstoque.push(e.abertas)
      }

      for (let index = 0; index <= (d2.length - 1); index++) {
        const e = d2[index]
        let data = (MetodosGlobais.mapeiaMesAbreviacao(MetodosGlobais.dateToJsonDateParts(e.data_estado_estoque).mes).nome)

        if (index - 1 >= 0) {
          if (e.abertas) {
            this.proporcao.push((d2[index - 1].abertas / e.abertas) * 100)
            vectorAbertas2.push({ x: data, y: (e.abertas - d2[index - 1].abertas) })
          }
        }
        vetorEstoque2.push(e.abertas)
      }
      corDataset = cores[11]

      chartData.datasets.push({
        label: 'Solicitações em Estoque dos Últimos 6 Meses',
        fill: false,
        backgroundColor: CorUtils.setAlpha(corDataset, 100),
        borderColor: CorUtils.setAlpha(corDataset, 70),
        data: vetorEstoque,
        yAxisID: 'y-axis-1',
        datalabels: {
          formatter: (value, context) => {
            return value.toLocaleString('pt-BR') + this.calcularDiferencaPerc(value, this.chartDataEvolucaoEstoque.chartData.datasets[1].data[context.dataIndex])
          },
          font: {
            weight: 'bold',
            size: 14,
          },
          display: true,
          align: 'top',
        },
      })

      corDataset = cores[3]

      chartData.datasets.push({
        label: 'Solicitações em Estoque dos 6 Meses do Período Passado',
        fill: false,
        backgroundColor: CorUtils.setAlpha(corDataset, 100),
        borderColor: CorUtils.setAlpha(corDataset, 70),
        data: vetorEstoque2,
        yAxisID: 'y-axis-1',
        datalabels: {
          formatter: (value, context) => {
            return value.toLocaleString('pt-BR')
          },
          font: {
            weight: 'bold',
            size: 14,
          },
          display: true,
          align: 'top',
        },
      })

      return { chartData: chartData, options: this.getOptions(legendaX, legendaY, false, true, true) }
    },

    getOptions (legendaX, legendaY, percentual = true, milhar = false, displayLegend = true) {
      return {
        layout: {
          padding: {
            top: 10,
            right: 30
          },
        },
        hover: {
          mode: 'x',
        },
        plugins: {
          datalabels: {
          },
          title: {
            display: true,
            text: 'Solicitações recebidas ontem',
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 4,

        tooltips: {
          mode: 'x',
          intersect: true,
          callbacks: this.tooltipsCallback(percentual, milhar),
        },
        scales: {
          xAxes: [{
            position: 'bottom',
            //type: 'linear',
            //distribution: 'linear',
            //time: { unit: 'month' },
            display: true,
            scaleLabel: {
              display: true,
              labelString: 'Mês',
            },
            gridLines:{
              display: true,
            },
            ticks: {
              autoSkip: false,
              beginAtZero: true,
            },
          }],
          yAxes: [{
            ticks: {
              autoSkip: true,
              beginAtZero: false,
              display: false,
              callback: (value) => value.toLocaleString('pt-BR'),
            },
            gridLines:{
              display: false,
            },
            id: 'y-axis-1',
            type: 'linear',
            position: 'left',
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t(legendaY || 'LegendaY'),
            },
          },
          ],
        },
        legend: {
          display: displayLegend,
          position: 'bottom'
        },
      }
    },

    calcularDiferencaPerc(val1, val2) {
      if(val1 > val2)
        return ("\n+" + (parseFloat((val1*100/val2).toFixed(2)).toLocaleString('pt-BR')+"%"))
      else if(val1 < val2)
        return ("\n-" + (parseFloat((val1*100/val2).toFixed(2)).toLocaleString('pt-BR')+"%"))
      else return '\n0%'
    },

    getLineAreaDataSet (label, fill, backgroundColor, borderColor, yAxisID, data) {
      return {
        label: label,
        fill: fill,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        data: data,
        yAxisID: yAxisID,
      }
    },

    isNullOrUndefined (el, atr, nA) {
      return MetodosGlobais.isNullOrUndefined(el, atr, nA)
    },

    // Esse metodo só funciona para datasets con eixos lineares, não funciona com categorias
    getVariacaoEstoque (value, context) {
      let indiceAtual = _.findIndex(context.dataset.data, (d) => { return d.x === value.x })
      if (indiceAtual > 0) {
        const a = context.dataset.data[indiceAtual].y
        const b = context.dataset.data[indiceAtual - 1].y
        return (((a - b) / a) * 100)
      } else {
        console.error('getVariacaoEstoque : Não é possivel Calcular a Variação do indice 0')
        return 0
      }
    },

    getPercentualPie (value, context) {
      let total = _.reduce(context.dataset.data, function (sum, n) {
        return sum + n
      }, 0)
      return (((total - value) / total) * 100)
    },

    montarGraficoCanais (dados, datasetLabel) {
      let chartData = { datasets: [], labels: [] }
      let dataset = {
        label: datasetLabel,
        backgroundColor: CorUtils.getVetorCoresPorTom('medio').slice(7, 11),
        data: [],
        datalabels: {
          formatter: (value, context) => {
            return value.toLocaleString('pt-BR') + '%'
          },
        },
      }
      dados = _.orderBy(dados, 'total', ['desc'])
      dados.forEach(o => {
        chartData.labels.push(o.de_canal)
        dataset.data.push(o.perc)
      })

      chartData.datasets.push(dataset)
      chartData.extra = dados

      this.chartCanais.data = chartData

      this.chartCanais.options = {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 75,
            bottom: 0,
          },
        },
        plugins: {
          datalabels: {
            font: {
              size: 14,
              weight: 'bold',
            },
            anchor: 'end',
            align: 'end',
            color: '#000',
            display: 'auto',
            offset: -5,
            rotation: 35
          },
        },
        tooltips: {
          enabled: true,
          callbacks: {
              label: function (tooltipItem, data) {
                let dataLabel = data.labels[tooltipItem.index]
                let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                return dataLabel + ': ' + value.toLocaleString('pt-BR') + '%'
              }
          },
        },
      }
    },

  },
}
</script>

<style lang="scss" scoped>
    .dataBold{
      font-weight: bold;
    }
    .verde {
        color: rgb(56, 118, 29);
        font-weight: bold;
        background-color: rgb(183, 225, 205) !important;
    }
    .vermelho {
        color: rgb(156, 0, 6);
        font-weight: bold;
        background-color: rgb(255, 199, 206) !important;
    }
    .amarelo {
        color: black;
        font-weight: bold;
        background-color: rgb(255, 229, 153) !important;
    }
    .cinzaClaro{
      color: black;
      font-weight: bold;
      background-color: rgb(217, 217, 217);
    }
    .cinza {
        color: black;
        font-weight: bold;
        background-color: rgb(183, 183, 183) !important;
    }
    .cinzaEscuro {
        color: black;
        font-weight: bold;
        background-color: rgb(102, 102, 102) !important;
    }
    .red-arrow{
      color: $theme-red;
    }
    .green-arrow{
      color: $vue-green;
    }
    .blue-arrow{
      color: $theme-blue;
    }
    .piechart{
      height: 25rem;
    }

    .chart{
      height: 25em;
    }

  #cardBoletimtop10{
    // .va-card{
    //   &__footer{
    //     background-color: rgb(217, 217, 217);
    //     &-title {
    //       font-weight: 200;
    //     }
    //   }
    // }
  }
</style>
